import { render, staticRenderFns } from "./InactiveList.vue?vue&type=template&id=c04ff296&scoped=true&"
import script from "./InactiveList.vue?vue&type=script&lang=js&"
export * from "./InactiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04ff296",
  null
  
)

export default component.exports